// src/components/PlatformBackButton.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PlatformBackButton.css';

const PlatformBackButton = ({
    to,
    step,
    onClick,
    className = '',
    children,
    label = 'Volver',
    ...rest
}) => {
    const navigate = useNavigate();

    const handleClick = (event) => {
        if (onClick) {
            onClick(event);
            if (event.defaultPrevented) {
                return;
            }
        }

        if (typeof step === 'number') {
            navigate(step);
            return;
        }

        if (typeof to === 'string') {
            navigate(to);
            return;
        }

        navigate(-1);
    };

    const classes = ['platform-back-button', className].filter(Boolean).join(' ');

    return (
        <button
            type="button"
            className={classes}
            onClick={handleClick}
            {...rest}
        >
            {children || label}
        </button>
    );
};

export default PlatformBackButton;
